import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  imports: [RouterLink],
  selector: 'pp-logo-main',
  templateUrl: './logo-main.component.html',
  styleUrls: ['./logo-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoMainComponent {
  get logo() {
    return 'assets/icons.svg#old-logo';
  }
}
